import React from "react";
import {
  Box,
  Chip,
  Drawer,
  IconButton,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
} from "@mui/material";
import {
  CloseRounded as CloseRoundedIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
  ListOutlined as ListOutlinedIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { getFileTypeIcon } from "../../../../icons/FileTypeIcons";
import formatFileSize from "../../../../utils/formatFileSize";
import moment from "moment";
import agent from "../../../../agent/agent";
import {getUrlForStaticApi} from "../../../../utils/urlStaticFiles";
import {
  getAddressToComplexUrl,
} from "../../../../utils/sectionNavigation";
import {
  formatLocationFieldValue,
  getLocationAddressText,
  getLocationClasses,
  getLocationCoordinatesLabel,
  getLocationDevices,
  getLocationEntityTypeLabels,
} from "../../../../utils/addressFields";

const ExhibitionReportsIcon = ({ active }) => active ? (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 3H6C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6V18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H18C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18V6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3ZM6 5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6V14.36L15.8 11.63C15.3042 11.222 14.6821 10.999 14.04 10.999C13.3979 10.999 12.7758 11.222 12.28 11.63L5 17.7V6C5 5.73478 5.10536 5.48043 5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5V5Z" fill="currentColor"/>
    <path d="M8 10C8.82843 10 9.5 9.32843 9.5 8.5C9.5 7.67157 8.82843 7 8 7C7.17157 7 6.5 7.67157 6.5 8.5C6.5 9.32843 7.17157 10 8 10Z" fill="currentColor"/>
  </svg>
) : (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 3H6C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6V18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H18C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18V6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3ZM6 5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6V14.36L15.8 11.63C15.3042 11.222 14.6821 10.999 14.04 10.999C13.3979 10.999 12.7758 11.222 12.28 11.63L5 17.7V6C5 5.73478 5.10536 5.48043 5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5V5ZM18 19H6.56L13.56 13.16C13.6945 13.0602 13.8575 13.0062 14.025 13.0062C14.1925 13.0062 14.3555 13.0602 14.49 13.16L19 17V18C19 18.2652 18.8946 18.5196 18.7071 18.7071C18.5196 18.8946 18.2652 19 18 19Z" fill="currentColor"/>
    <path d="M8 10C8.82843 10 9.5 9.32843 9.5 8.5C9.5 7.67157 8.82843 7 8 7C7.17157 7 6.5 7.67157 6.5 8.5C6.5 9.32843 7.17157 10 8 10Z" fill="currentColor"/>
  </svg>
);

const CloudDownloadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_906_17595)">
      <path d="M11.9248 13.6498L10.8332 14.6998V9.99984C10.8332 9.77882 10.7454 9.56686 10.5891 9.41058C10.4328 9.2543 10.2208 9.1665 9.99983 9.1665C9.77882 9.1665 9.56685 9.2543 9.41057 9.41058C9.25429 9.56686 9.1665 9.77882 9.1665 9.99984V14.6582L8.0915 13.5748C8.0138 13.4971 7.92156 13.4355 7.82004 13.3935C7.71852 13.3514 7.60971 13.3298 7.49983 13.3298C7.38995 13.3298 7.28114 13.3514 7.17962 13.3935C7.0781 13.4355 6.98586 13.4971 6.90816 13.5748C6.83046 13.6525 6.76883 13.7448 6.72678 13.8463C6.68473 13.9478 6.66309 14.0566 6.66309 14.1665C6.66309 14.2764 6.68473 14.3852 6.72678 14.4867C6.76883 14.5882 6.83046 14.6805 6.90816 14.7582L9.40816 17.2582C9.48603 17.3354 9.57838 17.3965 9.67991 17.438C9.78144 17.4795 9.89016 17.5005 9.99983 17.4998C10.2144 17.499 10.4203 17.4154 10.5748 17.2665L13.0748 14.8498C13.1633 14.7769 13.2357 14.6864 13.2876 14.5842C13.3394 14.482 13.3697 14.3702 13.3764 14.2557C13.3831 14.1413 13.3661 14.0267 13.3264 13.9191C13.2868 13.8115 13.2254 13.7133 13.1461 13.6305C13.0668 13.5477 12.9712 13.4822 12.8654 13.438C12.7596 13.3939 12.6459 13.372 12.5312 13.3738C12.4166 13.3757 12.3036 13.4011 12.1993 13.4486C12.0949 13.4961 12.0015 13.5646 11.9248 13.6498V13.6498Z" fill="currentColor"/>
      <path d="M14.7252 5.8334C14.3851 4.85094 13.7473 3.99891 12.9004 3.39587C12.0536 2.79282 11.0398 2.46875 10.0002 2.46875C8.96052 2.46875 7.94674 2.79282 7.09988 3.39587C6.25302 3.99891 5.61519 4.85094 5.27516 5.8334C4.52645 5.93368 3.81909 6.23561 3.22874 6.70689C2.63839 7.17818 2.18727 7.80108 1.92363 8.50897C1.65999 9.21687 1.59375 9.98311 1.732 10.7257C1.87024 11.4684 2.20778 12.1595 2.70849 12.7251C2.76897 12.8316 2.8522 12.9235 2.95225 12.9942C3.05229 13.0649 3.1667 13.1127 3.28731 13.1341C3.40793 13.1556 3.53179 13.1501 3.65008 13.1183C3.76836 13.0864 3.87816 13.0288 3.97166 12.9496C4.06515 12.8705 4.14005 12.7717 4.191 12.6603C4.24196 12.5489 4.26773 12.4276 4.26647 12.3051C4.26521 12.1826 4.23696 12.0619 4.18373 11.9515C4.1305 11.8412 4.05359 11.744 3.95849 11.6667C3.63609 11.3063 3.42514 10.8601 3.35123 10.3821C3.27732 9.90423 3.3436 9.41513 3.54205 8.97413C3.7405 8.53312 4.0626 8.15914 4.46932 7.89751C4.87603 7.63587 5.3499 7.49781 5.83349 7.50007H5.91682C6.11178 7.504 6.30194 7.43944 6.45421 7.31763C6.60647 7.19581 6.7112 7.02446 6.75016 6.8334C6.90317 6.07987 7.31198 5.40242 7.90732 4.91581C8.50266 4.42921 9.24792 4.16339 10.0168 4.16339C10.7857 4.16339 11.531 4.42921 12.1263 4.91581C12.7217 5.40242 13.1305 6.07987 13.2835 6.8334C13.3224 7.02446 13.4272 7.19581 13.5794 7.31763C13.7317 7.43944 13.9219 7.504 14.1168 7.50007H14.1668C14.6504 7.49781 15.1243 7.63587 15.531 7.89751C15.9377 8.15914 16.2598 8.53312 16.4583 8.97413C16.6567 9.41513 16.723 9.90423 16.6491 10.3821C16.5752 10.8601 16.3642 11.3063 16.0418 11.6667C15.9684 11.7491 15.9121 11.8451 15.8761 11.9494C15.8401 12.0536 15.8251 12.164 15.8321 12.2741C15.8391 12.3841 15.8679 12.4917 15.9167 12.5906C15.9656 12.6895 16.0336 12.7777 16.1168 12.8501C16.2687 12.984 16.4643 13.0581 16.6668 13.0584C16.7851 13.0582 16.9021 13.0329 17.0098 12.9841C17.1176 12.9352 17.2137 12.864 17.2918 12.7751C17.8064 12.2104 18.1559 11.5152 18.302 10.7653C18.4481 10.0155 18.3853 9.23991 18.1204 8.52338C17.8554 7.80684 17.3986 7.17693 16.7998 6.70251C16.201 6.22809 15.4833 5.92743 14.7252 5.8334V5.8334Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_906_17595">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const classColors = {
  'Стационарный': { backgroundColor: '#E4FBF1', color: '#1CA673' },
  'Мобильный': { backgroundColor: '#FFF9E6', color: '#FFC107' },
  'Передвижной': { backgroundColor: '#E3F2FD', color: '#2196F3' },
};

const AddressDrawer = ({ open, item, contractId, onClose }) => {
  const classes = useDrawerStyles();
  const [activeTab, setActiveTab] = React.useState("info");
  const [docCount, setDocCount] = React.useState(0);
  const [mediaCount, setMediaCount] = React.useState(0);
  const [exhibitionDrilled, setExhibitionDrilled] = React.useState(false);
  const exhibitionBackRef = React.useRef(null);

  React.useEffect(() => { if (open) setActiveTab("info"); }, [open]);
  React.useEffect(() => {
    if (activeTab !== "exhibitions") setExhibitionDrilled(false);
  }, [activeTab]);

  if (!item) return null;

  const devices = getLocationDevices(item);
  const entityTypes = getLocationEntityTypeLabels(item);
  const locationClasses = getLocationClasses(item);
  const coordinates = getLocationCoordinatesLabel(item);
  // location / latitude_complex / longitude_complex — поля ответа /operator/locations
  const locationText = formatLocationFieldValue(
    getLocationAddressText(item) || item.location || item.address || item.address_cam
  );
  const documentsEntityId = item.address_id ?? item.address_cam_id ?? item.id;
  const documentsItemName = devices.map((d) => d.serial).filter(Boolean).join(", ") || item.complex_serial;

  const tabs = [
    { key: "info", Icon: ListOutlinedIcon, label: "Адрес" },
    { key: "documents", Icon: DescriptionOutlinedIcon, label: "Документы" },
    { key: "exhibitions", Icon: ExhibitionReportsIcon, label: "Отчеты по выставлениям" }
  ];

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ className: classes.paper }} sx={{ "& .MuiDrawer-paper": { right: "10px !important" } }}>
      <div className={classes.main}>
        <div className={classes.sideRail}>
          {tabs.map(({ key, Icon, label }) => (
            <IconButton key={key} aria-label={label} title={label} className={`${classes.railBtn} ${activeTab === key ? classes.railBtnActive : ""}`} onClick={() => setActiveTab(key)} size="small">
              {key === "exhibitions" ? <Icon active={activeTab === key} /> : <Icon sx={{ fontSize: 20 }} />}
            </IconButton>
          ))}
        </div>
        <div className={classes.content}>
          <div className={classes.drawerHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography className={classes.drawerTitle}>{activeTab === "info" ? "Адрес" : activeTab === "exhibitions" ? "Отчеты по выставлениям" : "Документы"}</Typography>
              {activeTab === "documents" && <span style={{ fontSize: 12, fontWeight: 500, color: "#432DD7", backgroundColor: "#E0E7FF", borderRadius: 16, padding: "2px 8px" }}>{docCount}</span>}
              {activeTab === "exhibitions" && !exhibitionDrilled && <span style={{ fontSize: 12, fontWeight: 500, color: "#432DD7", backgroundColor: "#E0E7FF", borderRadius: 16, padding: "2px 8px" }}>{mediaCount}</span>}
            </Box>
            <IconButton onClick={onClose} size="small"><CloseRoundedIcon fontSize="small" /></IconButton>
          </div>
          <div className={classes.body}>
            {activeTab === "info" && (
              <>
                <div className={classes.row}><span className={classes.label}>Местоположение</span><span className={classes.value}>{locationText}</span></div>
                <div className={classes.row}><span className={classes.label}>Координаты</span><span className={classes.value}>{coordinates}</span></div>
                <div className={classes.row}><span className={classes.label}>Дата последнего использования</span><span className={classes.value}>{formatLocationFieldValue(item.last_date, { date: true })}</span></div>
                <div className={classes.row}><span className={classes.label}>Район</span><span className={classes.value}>{formatLocationFieldValue(item.district)}</span></div>
                <div className={classes.row}><span className={classes.label}>Автодорога</span><span className={classes.value}>{formatLocationFieldValue(item.road_name)}</span></div>
                <div className={classes.row}><span className={classes.label}>Километр</span><span className={classes.value}>{formatLocationFieldValue(item.km)}</span></div>
                <div className={classes.row}><span className={classes.label}>Метр</span><span className={classes.value}>{formatLocationFieldValue(item.m)}</span></div>
                <div className={classes.row}><span className={classes.label}>Значение автодороги</span><span className={classes.value}>{formatLocationFieldValue(item.road_importance)}</span></div>
                <div className={classes.row}>
                  <span className={classes.label}>Комплекс/камера</span>
                  <span className={classes.value} style={{ whiteSpace: "pre-line" }}>
                    {(entityTypes.length > 0 ? entityTypes : ["Н/Д"]).map((label, index, arr) => (
                      <React.Fragment key={`etype-${index}`}>
                        {label}{index < arr.length - 1 ? ",\n" : ""}
                      </React.Fragment>
                    ))}
                  </span>
                </div>
                <div className={classes.row}>
                  <span className={classes.label}>Тип комплекса</span>
                  <span className={classes.value} style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
                    {(locationClasses.length > 0 ? locationClasses : ["Н/Д"]).map((classLabel, index) => {
                      const colors = classColors[classLabel] || { backgroundColor: "#F4F4F5", color: "#71717A" };
                      return (
                        <Chip
                          key={`class-${index}-${classLabel}`}
                          label={classLabel}
                          size="small"
                          sx={{ fontWeight: 600, fontSize: 12, ...colors }}
                        />
                      );
                    })}
                  </span>
                </div>
                <div className={classes.row}>
                  <span className={classes.label}>Номер устройства</span>
                  <span className={classes.value} style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {(devices.length > 0 ? devices : [{ serial: "", id: null }]).map((device, index, arr) => {
                      const serial = device.serial || "Н/Д";
                      const href = getAddressToComplexUrl(item, device);
                      const suffix = index < arr.length - 1 ? "," : "";
                      if (href && device.serial) {
                        return (
                          <Box
                            key={device.id || `serial-${index}`}
                            component="a"
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              color: "#4F39F6",
                              textDecoration: "underline",
                              fontSize: 14,
                              lineHeight: "20px",
                              "&:hover": { color: "#432DD7" },
                            }}
                          >
                            {serial}{suffix}
                          </Box>
                        );
                      }
                      return (
                        <span key={device.id || `serial-${index}`}>
                          {serial}{suffix}
                        </span>
                      );
                    })}
                  </span>
                </div>
              </>
            )}
            {activeTab === "documents" && <AddressDocuments itemId={documentsEntityId} itemName={documentsItemName} onDocCountChange={setDocCount} />}
            {activeTab === "exhibitions" && (
              <AddressExhibitionMedia
                locationId={documentsEntityId}
                contractId={contractId}
                onCountChange={setMediaCount}
                onDrilledChange={setExhibitionDrilled}
                backRef={exhibitionBackRef}
              />
            )}
          </div>
          {activeTab === "exhibitions" && exhibitionDrilled && (
            <div className={classes.exhibitionFooter}>
              <button type="button" className={classes.backBtn} onClick={() => exhibitionBackRef.current?.()}>Назад</button>
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
};
const PhotoSlider = ({ photos, index, onClose, onIndex }) => {
  const total = photos.length;
  const photo = photos[index];
  const src = getUrlForStaticApi(photo?.url || photo?.thumbnail_url);

  React.useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowLeft" && total > 1) onIndex((index - 1 + total) % total);
      if (event.key === "ArrowRight" && total > 1) onIndex((index + 1) % total);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, total, onClose, onIndex]);

  const shift = (step) => (event) => {
    event.stopPropagation();
    onIndex((index + step + total) % total);
  };

  return (
    <Box
      onClick={onClose}
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 1600,
        backgroundColor: "rgba(24, 24, 27, 0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {total > 1 && (
        <IconButton onClick={shift(-1)} sx={{ position: "absolute", left: 24, width: 40, height: 40, borderRadius: "8px", backgroundColor: "#FFFFFF", "&:hover": { backgroundColor: "#F4F4F5" } }}>
          <ChevronLeftIcon />
        </IconButton>
      )}
      <Box
        component="img"
        src={src}
        alt=""
        onClick={(event) => event.stopPropagation()}
        sx={{ maxWidth: "min(920px, 72vw)", maxHeight: "80vh", borderRadius: "12px", objectFit: "contain", backgroundColor: "#FFFFFF" }}
      />
      {total > 1 && (
        <IconButton onClick={shift(1)} sx={{ position: "absolute", right: 24, width: 40, height: 40, borderRadius: "8px", backgroundColor: "#FFFFFF", "&:hover": { backgroundColor: "#F4F4F5" } }}>
          <ChevronRightIcon />
        </IconButton>
      )}
    </Box>
  );
};

const FolderIcon = () => (
  <svg width="88" height="88" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M89.3748 93.9585H20.6248C17.6301 93.9953 14.7429 92.8439 12.5953 90.7564C10.4477 88.669 9.21478 85.8156 9.1665 82.821V27.1794C9.21478 24.1848 10.4477 21.3314 12.5953 19.244C14.7429 17.1565 17.6301 16.0051 20.6248 16.0419H41.7082C42.3852 16.0463 43.0527 16.2007 43.663 16.494C44.2732 16.7872 44.8108 17.2119 45.2373 17.7377L57.154 32.3127H89.2373C90.7317 32.2762 92.2185 32.536 93.6119 33.0771C95.0053 33.6182 96.2777 34.4299 97.3558 35.4654C98.4339 36.5009 99.2962 37.7396 99.8931 39.11C100.49 40.4805 100.809 41.9556 100.833 43.4502V82.821C100.785 85.8156 99.552 88.669 97.4044 90.7564C95.2568 92.8439 92.3695 93.9953 89.3748 93.9585V93.9585Z" fill="#7C86FF"/>
  </svg>
);

const AddressExhibitionMedia = ({ locationId, contractId, onCountChange, onDrilledChange, backRef }) => {
  const [dates, setDates] = React.useState([]);
  const [openedDate, setOpenedDate] = React.useState(null);
  const [openedComplex, setOpenedComplex] = React.useState(null);
  const [slideIndex, setSlideIndex] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const loadedRef = React.useRef(null);

  React.useEffect(() => {
    if (!locationId || !contractId) return;
    const requestKey = `${locationId}:${contractId}`;
    if (loadedRef.current === requestKey) return;
    loadedRef.current = requestKey;
    setOpenedDate(null);
    setOpenedComplex(null);
    setIsLoading(true);
    setErrorMessage("");
    agent.get(`/operator/locations/${encodeURIComponent(locationId)}/media`, {
      params: { contract_id: contractId },
    })
      .then((res) => {
        const list = Array.isArray(res?.data?.data?.dates) ? res.data.data.dates : [];
        setDates(list);
        onCountChange?.(list.length);
      })
      .catch((err) => {
        setDates([]);
        onCountChange?.(0);
        setErrorMessage(err?.response?.data?.details || err?.response?.data?.message || "Не удалось загрузить отчеты");
      })
      .finally(() => setIsLoading(false));
  }, [locationId, contractId, onCountChange]);

  React.useEffect(() => {
    onDrilledChange?.(Boolean(openedDate));
  }, [openedDate, onDrilledChange]);

  if (backRef) {
    backRef.current = openedDate
      ? () => {
        if (openedComplex) setOpenedComplex(null);
        else setOpenedDate(null);
      }
      : null;
  }

  if (isLoading) return <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><CircularProgress size={28} /></Box>;
  if (errorMessage) return <Typography sx={{ fontSize: 14, color: "#71717A", py: 4, textAlign: "center" }}>{errorMessage}</Typography>;
  if (dates.length === 0) return <Typography sx={{ fontSize: 14, color: "#71717A", py: 4, textAlign: "center" }}>Отчеты не найдены</Typography>;

  const crumbSx = {
    border: 0,
    background: "none",
    margin: 0,
    padding: 0,
    font: "inherit",
    fontSize: 14,
    lineHeight: "20px",
    height: 20,
  };
  const crumbLinkSx = {
    ...crumbSx,
    color: "#71717A",
    cursor: "pointer",
    "&:hover": { color: "#000000" },
  };
  const folderGridSx = {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "8px 12px",
  };
  const folderButtonSx = {
    border: 0,
    background: "none",
    margin: 0,
    padding: "8px 4px",
    width: "100%",
    cursor: "pointer",
    font: "inherit",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    borderRadius: "8px",
    "&:hover": { backgroundColor: "#F4F4F5" },
  };

  if (openedDate) {
    const dateLabel = moment(openedDate.date).format("DD.MM.YYYY");
    const complexes = openedDate.complexes || [];
    const photos = openedComplex?.photos || [];
    return (
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: 2, height: 20 }}>
          <Box
            component="button"
            onClick={() => { setOpenedDate(null); setOpenedComplex(null); }}
            sx={crumbLinkSx}
          >
            Все отчеты
          </Box>
          <Box component="span" sx={{ ...crumbSx, color: "#A1A1AA" }}>/</Box>
          {openedComplex ? (
            <Box
              component="button"
              onClick={() => setOpenedComplex(null)}
              sx={crumbLinkSx}
            >
              {dateLabel}
            </Box>
          ) : (
            <Box component="span" sx={{ ...crumbSx, color: "#4F39F6" }}>{dateLabel}</Box>
          )}
          {openedComplex ? (
            <>
              <Box component="span" sx={{ ...crumbSx, color: "#A1A1AA" }}>/</Box>
              <Box component="span" sx={{ ...crumbSx, color: "#4F39F6" }}>{openedComplex.complex_serial_number}</Box>
            </>
          ) : null}
        </Box>
        {openedComplex ? (
          photos.length === 0 ? (
            <Typography sx={{ fontSize: 14, color: "#71717A", py: 4, textAlign: "center" }}>Отчеты не найдены</Typography>
          ) : (
            <>
              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: "16px 12px" }}>
                {photos.map((photo, photoIndex) => {
                  const preview = getUrlForStaticApi(photo.thumbnail_url || photo.url);
                  return (
                    <Box
                      key={photo.id}
                      component="button"
                      type="button"
                      onClick={() => setSlideIndex(photoIndex)}
                      sx={{ display: "block", padding: 0, border: 0, cursor: "pointer", borderRadius: "8px", overflow: "hidden", aspectRatio: "1 / 1", backgroundColor: "#F4F4F5" }}
                    >
                      <Box component="img" src={preview} alt="" sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                    </Box>
                  );
                })}
              </Box>
              {slideIndex != null && (
                <PhotoSlider
                  photos={photos}
                  index={slideIndex}
                  onIndex={setSlideIndex}
                  onClose={() => setSlideIndex(null)}
                />
              )}
            </>
          )
        ) : complexes.length === 0 ? (
          <Typography sx={{ fontSize: 14, color: "#71717A", py: 4, textAlign: "center" }}>Отчеты не найдены</Typography>
        ) : (
          <Box sx={folderGridSx}>
            {complexes.map((complex, index) => (
              <Box
                key={`${complex.complex_serial_number || "complex"}-${index}`}
                component="button"
                onClick={() => setOpenedComplex(complex)}
                sx={folderButtonSx}
              >
                <FolderIcon />
                <Typography sx={{ fontSize: 14, color: "#27272A", lineHeight: "20px" }}>
                  {complex.complex_serial_number || "Н/Д"}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box>
      <Typography sx={{ fontSize: 14, lineHeight: "20px", height: 20, color: "#71717A", mb: 2 }}>Все отчеты</Typography>
      <Box sx={folderGridSx}>
        {dates.map((entry) => (
          <Box
            key={entry.date}
            component="button"
            onClick={() => setOpenedDate(entry)}
            sx={folderButtonSx}
          >
            <FolderIcon />
            <Typography sx={{ fontSize: 14, color: "#27272A", lineHeight: "20px" }}>
              {moment(entry.date).format("DD.MM.YYYY")}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const AddressDocuments = ({ itemId, itemName, onDocCountChange }) => {
  const classes = useDocTableStyles();
  const [documents, setDocuments] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const loadedRef = React.useRef(null);

  React.useEffect(() => {
    if (!itemId || loadedRef.current === itemId) return;
    loadedRef.current = itemId;
    setIsLoading(true);
    const params = new URLSearchParams({
      linked_entity_id: itemId,
      hide_from_user: "false"
    });
    // if (itemName) params.set("linked_entity_name", itemName);
    agent.get(`/documents?${params.toString()}`)
      .then((res) => {
        const docs = res?.data?.data || [];
        setDocuments(docs);
        onDocCountChange?.(docs.length);
      })
      .catch(() => {
        setDocuments([]);
        onDocCountChange?.(0);
      })
      .finally(() => setIsLoading(false));
  }, [itemId, onDocCountChange]);

  if (isLoading) return <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><CircularProgress size={28} /></Box>;
  if (documents.length === 0) return <Typography sx={{ fontSize: 14, color: "#71717A", py: 4, textAlign: "center" }}>Документы не найдены</Typography>;

  return (
    <Table size="small" className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.thName}>Название</TableCell>
          <TableCell>Тип документа</TableCell>
          <TableCell className={classes.thDate}>Дата загрузки</TableCell>
          <TableCell className={classes.thAction} />
        </TableRow>
      </TableHead>
      <TableBody>
        {documents.map((doc) => {
          const FileIcon = getFileTypeIcon(doc.format);
          return (
            <TableRow key={doc.id} hover>
              <TableCell>
                <div className={classes.nameCell}>
                  <FileIcon className={classes.fileIcon} />
                  <div className={classes.nameInfo}>
                    <span className={classes.fileName}>{doc.original_name}</span>
                    {doc.size > 0 && <span className={classes.fileSize}>{formatFileSize(doc.size)}</span>}
                  </div>
                </div>
              </TableCell>
              <TableCell className={classes.typeCell}>{doc.type_name}</TableCell>
              <TableCell className={classes.dateCell}>{moment(doc.created).format("DD.MM.YYYY")}</TableCell>
              <TableCell>
                {doc.url && (
                  <IconButton size="small" className={classes.downloadBtn} onClick={() => window.open(getUrlForStaticApi(doc.url), '_blank')}>
                    <CloudDownloadIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

const useDrawerStyles = makeStyles(() => ({
  paper: {
    maxWidth: "100%", borderLeft: "1px solid #E4E4E7", zIndex: "1400 !important",
    boxShadow: "-8px 0 24px -4px rgba(0, 0, 0, 0.08)", width: "100%",
    "@media (min-width: 600px)": { width: 720, top: 12, height: "calc(100% - 24px)", borderRadius: 10 },
  },
  main: { display: "flex", height: "100%" },
  sideRail: {
    width: 48, flexShrink: 0, borderRight: "1px solid #E4E4E7",
    backgroundColor: "#FAFAFA", display: "flex", flexDirection: "column",
    alignItems: "center", paddingTop: 12, gap: 4,
  },
  railBtn: { width: 36, height: 36, borderRadius: 8, color: "#71717A", "&:hover": { backgroundColor: "#F4F4F5" } },
  railBtnActive: { backgroundColor: "#E0E7FF !important", color: "#432DD7 !important" },
  content: { flex: 1, display: "flex", flexDirection: "column", minWidth: 0 },
  drawerHeader: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "20px 24px 16px" },
  drawerTitle: { fontSize: 18, fontWeight: 600, color: "#27272A", lineHeight: "24px" },
  body: { flex: 1, overflow: "auto", padding: "0 24px 24px" },
  exhibitionFooter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    boxSizing: "border-box",
    height: 76,
    padding: "12px 32px 24px",
    background: "#FFFFFF",
    boxShadow: "0px -4px 8px rgba(24, 24, 27, 0.05)",
    flexShrink: 0,
  },
  backBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    minWidth: 40,
    height: 40,
    padding: "2px 16px",
    border: 0,
    borderRadius: 4,
    background: "#E0E7FF",
    color: "#432DD7",
    fontFamily: "Lato, sans-serif",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px",
    cursor: "pointer",
  },
  row: { display: "flex", alignItems: "flex-start", gap: 16, padding: "8px 0" },
  label: { width: 220, flexShrink: 0, fontSize: 14, color: "#71717A", lineHeight: "20px" },
  value: { flex: 1, fontSize: 14, color: "#27272A", lineHeight: "20px", minWidth: 0 },
}));
const useDocTableStyles = makeStyles(() => ({
  table: { "& .MuiTableCell-root": { borderColor: "#E4E4E7" } },
  thName: { minWidth: 200 },
  thDate: { whiteSpace: "nowrap" },
  thAction: { width: 48 },
  nameCell: { display: "flex", alignItems: "flex-start", gap: 8 },
  fileIcon: { fontSize: "20px !important", flexShrink: 0, marginTop: 2 },
  nameInfo: { minWidth: 0, display: "flex", flexDirection: "column" },
  fileName: { maxWidth: "160px", fontSize: 14, fontWeight: 500, color: "#27272A", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  fileSize: { fontSize: 12, color: "#71717A", lineHeight: "16px" },
  typeCell: { fontSize: 14, color: "#71717A" },
  dateCell: { fontSize: 14, whiteSpace: "nowrap" },
  downloadBtn: { color: "#A1A1AA", padding: 4 },
}));

export default AddressDrawer;
